import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditCategoryRes } from "./helper";

export const editCategory = async (params: {
  id: number;
  data: CategoryReqT;
}) => axios.put(Routes.EDIT_CATEGORY + "/" + params.id, { ...params.data });

export const useEditCategory = () =>
  useMutation({
    mutationKey: [Keys.EDIT_CATEGORY_MUT],
    mutationFn: editCategory,
    onSuccess: onEditCategoryRes,
  });
